import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ParseService } from '../../../../shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ToastrService } from 'ngx-toastr';
import { EncryptDecrypt } from 'app/shared/common/storage-setting/encryptdecrypt';
import { AddTimeSheetComponent } from 'app/shared/common/add-time-sheet/add-time-sheet.component';
import { MatDialog } from '@angular/material/dialog';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})

export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  loginFormErrors: any;
  queryRole: any;
  instance: any;
  admin: boolean = false;
  employee: boolean = false;
  payload: { userEmail: any; password: any; };
  dialogRef: any;
  hide = true;
  isDesktopAppVisible: boolean;
  todayTime = new Date().setHours(0, 0, 0, 0);
  tenantId: any;
  today: number;
  extendedExpiringDate: any;
  isTrailExpiry: boolean;
  sessionToken: any;
  industryId: any;
  isWebDesktop: any;

  /**
  * Constructor
  *
  * @param {FuseConfigService} _fuseConfigService
  * @param {FormBuilder} _formBuilder
  * @param {FuseNavigationService} _fuseNavigationService
  */
  constructor(
    private toastr: ToastrService,
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private storageConfiguration: StorageConfiguration,
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private encryptDecrypt: EncryptDecrypt,
    private dateServiceService: DateServiceService,
    private spinner: NgxSpinnerService
  ) {
    // Desktop using Login
    this.route.queryParams.subscribe(async params => {
      if (params.oxtn != undefined) {
        let decoded = decodeURIComponent(params.oxtn);
        let sessionToken = this.encryptDecrypt.decrypt(decoded);
        this.parseService.instance.User.become(sessionToken).then(x => {
          const myObject = JSON.parse(JSON.stringify(x));
          this.spinner.show();
          localStorage.setItem('loginType', 'Marketing');
          this.loginUser(myObject, x, '');
        });
      }
      else {
        return;
      }
    });

    // let sessionToken = decode(this.sessionToken);
    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };
  }

  /*
  ** ==========================================================
  ** On init
  ** ==========================================================
  */

  ngOnInit(): void {
    const emailRegEx = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailRegEx)]],
      password: ['', Validators.required]
    });
    this.loginForm.valueChanges.subscribe(() => {
      this.onLoginFormValuesChanged();
    });
  }

  onLoginFormValuesChanged() {
    for (const field in this.loginFormErrors) {
      if (!this.loginFormErrors.hasOwnProperty(field)) {
        continue;
      }
      // Clear previous errors
      this.loginFormErrors[field] = {};
      // Get the control
      const control = this.loginForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.loginFormErrors[field] = control.errors;
      }
    }
  }

  remember() {
    let payload = {
      userEmail: this.loginForm.value.email
    };
  }

  /*
  ** ==========================================================
  ** Login Validation
  ** ==========================================================
  */

  onSubmit() {
    if (!this.loginForm.valid) return;
    this.payload = {
      userEmail: this.loginForm.value.email,
      password: this.loginForm.value.password
    };

    const loginResult = this.parseService.instance.User.logIn(this.payload.userEmail, this.payload.password);
    loginResult.then(async res => {
      const myObject = JSON.parse(JSON.stringify(res));
      await this.getAppUsageDetails(myObject.profile.objectId);
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.sessiontoken, myObject.sessionToken);
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.tenantId, myObject.tenantId);
      this.storageConfiguration.sessionSetItem(this.storageConfiguration.userAuth, this.loginForm.value.password);
      this.loginUser(myObject, res, this.payload.password);
      // this.queryInterface.executeQueryWithRelation(this.parseService, '_Role', [
      //   { condition: 'equalTo', field: 'objectId', value: myObject.role.objectId }
      // ]).then(roleData => {
      //   myObject.role.name = roleData[0].attributes.name;
      //   if (myObject.desktopVerified && myObject.role.name !== 'Admin' || myObject.role.name == 'Admin') {
      //     this.storageConfiguration.sessionSetItem(this.storageConfiguration.sessiontoken, myObject.sessionToken);
      //     this.storageConfiguration.sessionSetItem(this.storageConfiguration.tenantId, myObject.tenantId);
      //     let profile = res.get('profile');

      //     this.userCheckByRole(profile, res);
      //   } else {
      //     // this.toastr.warning('Please Download and Logon to Desktop Application shown below.');
      //     this.toastr.warning('Please Download Our Desktop Application And Login To Continue.');
      //     this.isDesktopAppVisible = true;
      //     this.router.navigate(['/desktopApp']);
      //   }
      // });
    }, error => {
      this.toastr.error('Invalid username / password.');
    });
  }

  async loginUser(myObject, res, password) {
    this.setDesktopVerifiedDate(res.id);
    if (!myObject.role){
      myObject.role = myObject.profile.role;
    }
    this.queryInterface.executeQueryWithRelation(this.parseService, '_Role', [
      // { condition: 'equalTo', field: 'objectId', value: myObject.role.objectId }
    ]).then(async roleData => {
      myObject.role.name = roleData[0].attributes.name;
      if (myObject.desktopVerified && myObject.role.name !== 'Admin' || myObject.role.name == 'Admin') {
        this.storageConfiguration.sessionSetItem(this.storageConfiguration.sessiontoken, myObject.sessionToken);
        this.storageConfiguration.sessionSetItem(this.storageConfiguration.tenantId, myObject.tenantId);
        let profile = res.get('profile');

        await this.userCheckByRole(profile, res, password);
      } else {
        let profile = res.get('profile');
        if (this.isWebDesktop === false) {
          await this.userCheckByRole(profile, res, password);
          return;
        }
        // this.toastr.warning('Please Download Our Desktop Application And Login To Continue.');
        this.isDesktopAppVisible = false;
        const isDefaultAuth = (password === 'SmartWork@123');
        this.router.navigate(['/desktopApp'], { state: { myObject, isDefaultAuth } });
        this.spinner.hide();
      }
    });
  }

 /**
  * set desktotop verified date if date is not set when using web as desktop
  * @param userId
  */
  async setDesktopVerifiedDate(userId): Promise<void>{
    const User = this.parseService.instance.Object.extend('_User');
    const userClass = new this.parseService.instance.Query(User);
    userClass.equalTo('objectId', userId);
    let userResponse = await userClass.find();
    if (userResponse){
      userResponse = userResponse[0];
      const desktopVerfiedDate = userResponse.get('desktopVerfiedDate');
      if ( !desktopVerfiedDate){ // ! checking desktopVerfiedDate field is undefined
        userResponse.set('desktopVerfiedDate', new Date());
        userResponse.save();
      }
    }
  }

  async getAppUsageDetails(profileId): Promise<void> {
    const profileClass = this.parseService.instance.Object.extend('Profile');
    const query = new this.parseService.instance.Query(profileClass);
    query.equalTo('objectId', profileId);
    await query.find().then((res) => {
      this.isWebDesktop = res[0].get('isWebDesktop');
    });
  }

  async userCheckByRole(profile, user, password) {
    this.setIndustryId();
    this.queryInterface.executeQueryWithRelation(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'objectId', value: profile.id },
      { condition: 'include', value: 'role' }, { condition: 'include', value: 'department' }]).then(async results => {
        await this.getCustomerDetails();
        let result = results[0];
        if (result.get('isActive')) {
          let jsonText = JSON.stringify(result);
          let profile = JSON.parse(jsonText);
          let roleName = profile.role.name;
          let deptName = profile.department.name;
          let isFirstLogin = profile.isFirstLogin;

          if (roleName == 'CEO' || roleName == 'General Manager' || roleName == 'HR' || roleName == 'Admin' || deptName == 'Management') {
            this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'Admin');
          }
          else if ((roleName == 'Project Manager' || roleName == 'QA Lead' || roleName == 'Leader') && deptName != 'Management') {
            this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'Leader');
          }
          else if (roleName == 'IT Manager' && deptName != 'Management') {
            this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'IT Manager');
          }
          else {
            this.storageConfiguration.sessionSetItem(this.storageConfiguration.role, 'Employee');
          }
          this.storageConfiguration.sessionSetItem(this.storageConfiguration.isloggedIn, 'true');
          if (password === 'SmartWork@123') {
            this.toastr.success('Still using default Opnworx Password');
            this.router.navigate(['reset-password']);
            return;
          }
          if (roleName == 'CEO' || roleName == 'General Manager' || roleName == 'HR' || roleName == 'Admin') {
            this.toastr.success('Login successfully');
            if (this.isTrailExpiry) {
              this.router.navigate(['/plan-subscribe']); 
            } else {
              // await this.webUserTimeSheet();
              this.router.navigate(['/project-metrics']);
            }
          }
          else if (roleName == 'Project Manager' || roleName == 'QA Lead' || roleName == 'Leader' || deptName == 'Management') {
            this.toastr.success('Login successfully');
            // await this.webUserTimeSheet();
            this.router.navigate(['/project-metrics']);
          }

          else if (roleName == 'Graphic Designer' || roleName == 'QA' || roleName == 'Program Analyst' || roleName == 'Trainee'
            || roleName == 'System Admin' || roleName == 'IT Manager' || roleName == 'Software Engineer' || roleName === 'Employee') {
            this.toastr.success('Login successfully');
            if (isFirstLogin) {
              result.set('isFirstLogin', true);
              result.save();
              if (this.isTrailExpiry) {
                this.router.navigate(['/plan-subscribe']);
              } else {
                // await this.webUserTimeSheet();
                this.router.navigate(['/profile']);
              }
            } else {
              if (this.isTrailExpiry) {
                this.router.navigate(['/plan-subscribe']);
              } else {
                // await this.webUserTimeSheet();
                // this.router.navigate(['/employees-dashboard']);
                this.router.navigate(['/todo-list-item']);
              }
            }
          }
          this.spinner.hide();
        }
        else {
          this.toastr.warning('This user is in In-Active State. Contact Admin');
          localStorage.clear();
          this.spinner.hide();
        }
      });
  }

  async setIndustryId(): Promise<void> {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    const CustomerOnBoarding = this.parseService.instance.Object.extend('CustomerOnBoarding');
    const customerOnBoardingQuery = new this.parseService.instance.Query(CustomerOnBoarding);
    customerOnBoardingQuery.equalTo('tenantId', this.tenantId);
    let CustomerOnBoardingResult = await customerOnBoardingQuery.find();
    CustomerOnBoardingResult = CustomerOnBoardingResult[0];
    this.storageConfiguration.sessionSetItem(this.storageConfiguration.industryId, CustomerOnBoardingResult.get('industry').id);
    this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
  }

  async getCustomerDetails(): Promise<void> {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    const Customer = this.parseService.instance.Object.extend('Customer');
    const customerQuery = new this.parseService.instance.Query(Customer);
    customerQuery.equalTo('tenantId', this.tenantId);
    await customerQuery.find().then((customer) => {
      const customerData = customer[0];
      this.today = new Date().setHours(0, 0, 0, 0);
      this.extendedExpiringDate = customerData.get('extendedExpiringDate');
      if (this.today < this.extendedExpiringDate) {
        this.isTrailExpiry = false;
      } else {
        this.isTrailExpiry = true;
      }
    });
  }

  adminRegister() {
    this.router.navigate(['admin-register']);
  }

  // async webUserTimeSheet() {
  //   let profileId = this.parseService.instance.User.current().get('profile').id;

  //   let Profile = this.parseService.instance.Object.extend('Profile');
  //   let profile = new this.parseService.instance.Query(Profile);
  //   profile.equalTo('objectId', profileId);
  //   let isWebUser = await profile.find();
  //   let isWebDesktop = isWebUser[0].get('isWebDesktop');

  //   let UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
  //   let userTimeSheet = new this.parseService.instance.Query(UserTimeSheet);
  //   let todayDate = new Date();
  //   let currentDate = this.dateServiceService.startEndDateByDate(todayDate);
  //   userTimeSheet.greaterThan('createdAt', currentDate[0]);
  //   userTimeSheet.lessThan('createdAt', currentDate[1]);
  //   userTimeSheet.equalTo('profileId', { __type: "Pointer", className: "Profile", objectId: profileId })
  //   let userTimeSheetDetails = await userTimeSheet.find();
  //   if (userTimeSheetDetails.length == 0 && isWebDesktop) {
  //     this.dialog.open(AddTimeSheetComponent, {
  //       width: "560px",
  //       height: "35%",
  //       disableClose: true,
  //     });
  //   }
  // }

}
